//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Btn from './Btn.vue';
import CatalogSpoiler from './CatalogSpoiler.vue';
import CatalogTags from './CatalogTags.vue';
import CatalogBrands from './CatalogBrands.vue';
import CatalogTypes from './CatalogTypes.vue';
import CatalogFilter from './CatalogFilter.vue';

export default {
	name: 'CatalogMenu',

	components: {
		Btn: Btn,
		CatalogSpoiler: CatalogSpoiler,
		CatalogTags: CatalogTags,
		CatalogBrands: CatalogBrands,
		CatalogTypes: CatalogTypes,
		CatalogFilter: CatalogFilter
	},

	props: {
		tags: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		brands: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		types: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		filters: {
			type: Array,
			default: function _default() {
				return [];
			}
		},

		count: {
			type: String,
			default: ''
		}
	},

	data: function data() {
		return {
			showMenu: false,
			scrollPos: 0,
			isScrolling: false
		};
	},


	computed: {
		lang: function lang() {
			return this.$store.state.settings.lang;
		},
		catalogCategoriesTitle: function catalogCategoriesTitle() {
			return this.$lang('catalogCategories', null, this.lang);
		},
		catalogBrandsTitle: function catalogBrandsTitle() {
			return this.$lang('catalogBrands', null, this.lang);
		},
		catalogTypesTitle: function catalogTypesTitle() {
			return this.$lang('catalogTypes', null, this.lang);
		},
		filterBtnTitle: function filterBtnTitle() {
			return this.$lang('filterBtn', null, this.lang);
		},
		filterResetTitle: function filterResetTitle() {
			return this.$lang('filterReset', null, this.lang);
		},
		filterSelectedTitle: function filterSelectedTitle() {
			return this.$lang('filterSelected', null, this.lang);
		},
		tag: function tag() {
			var tag = this.$route.query.tag;

			if (!tag) return false;

			var tagData = this.tags.find(function (item) {
				return item.tag === tag;
			});

			if (!tagData) return false;

			var selected = {
				title: tagData.title,
				resetPath: this.$route.path
			};

			if (this.$route.query.filter) selected.resetPath += '?filter=' + this.$route.query.filter;

			return selected;
		},
		filter: function filter() {
			var _this = this;

			var params = (this.$route.query.filter || '').split(','),
			    selected = [];

			params.forEach(function (param) {
				var paramData = null;

				_this.filters.forEach(function (filter) {
					var data = filter.tags.find(function (item) {
						return item.tag === param;
					});
					if (data) paramData = data;
				});

				if (!paramData) return false;

				var selectedItem = {
					title: paramData.title,
					resetPath: ''
				},
				    path = '';

				if (_this.$route.query.tag) path += '?tag=' + _this.$route.query.tag;

				if (params.length > 1) {
					path += (path ? '&' : '?') + 'filter=' + params.filter(function (el) {
						return el !== param;
					}).join(',');
				}

				selectedItem.resetPath = _this.$route.path + path;
				selected.push(selectedItem);
			});

			return selected;
		},
		selected: function selected() {
			var arr = [];

			if (this.tag) arr.push(this.tag);
			if (this.filter) arr = arr.concat(this.filter);

			return arr;
		}
	},

	methods: {
		stickyHandler: function stickyHandler() {
			var menu = this.$refs.menu,
			    parent = menu.parentNode,
			    menuBounds = menu.getBoundingClientRect(),
			    parentBounds = parent.getBoundingClientRect(),
			    vh = document.documentElement.clientHeight,
			    scrollPos = window.pageYOffset,
			    menuOffsetTop = scrollPos - parent.offsetTop + menuBounds.top;

			if (menuBounds.height + 96 <= vh) {
				menu.style.position = 'sticky';
				menu.style.top = '96px';

				return;
			}

			parent.parentNode.style.minHeight = menuBounds.height + 'px';

			if (scrollPos > this.scrollPos) {
				// scrollDown

				var menuScrolled = menuBounds.bottom + 48 <= vh,
				    parentScrolled = parentBounds.bottom + 48 <= vh;

				if (menuScrolled && !parentScrolled) {
					this.isScrolling = false;

					menu.style.position = 'fixed';
					menu.style.top = menuBounds.top + 'px';
				} else if (parentScrolled) {
					this.isScrolling = false;

					menu.style.position = 'absolute';
					menu.style.top = parentBounds.height - menuBounds.height + 'px';
				} else if (!this.isScrolling) {
					this.isScrolling = true;

					menu.style.position = 'absolute';
					menu.style.top = menuOffsetTop + 'px';
				}
			} else {
				// scrollUp

				var _menuScrolled = menuBounds.top >= 96,
				    _parentScrolled = parentBounds.top >= 96;

				if (_menuScrolled && !_parentScrolled) {
					this.isScrolling = false;

					menu.style.position = 'fixed';
					menu.style.top = '96px';
				} else if (_parentScrolled) {
					this.isScrolling = false;

					menu.style.position = 'absolute';
					menu.style.top = '0px';
				} else if (!this.isScrolling) {
					this.isScrolling = true;

					menu.style.position = 'absolute';
					menu.style.top = menuOffsetTop + 'px';
				}
			}

			this.scrollPos = scrollPos;
		}
	},

	created: function created() {
		if (process.browser && document.documentElement.clientWidth > 1180) {
			window.addEventListener('scroll', this.stickyHandler);
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;
		}
	},
	destroyed: function destroyed() {
		if (process.browser && document.documentElement.clientWidth > 1180) {
			window.removeEventListener('scroll', this.stickyHandler);
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogMenu.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CatalogMenu.vue
// module chunks = 0